"use client"
import { useState, useEffect, useContext } from "react"
import {
  IconButton,
  Modal,
  Typography,
  Box,
  Paper,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Card,
  CardContent,
  alpha,
  Zoom,
  Button,
} from "@mui/material"

import { useTenantNavigation } from "../../hooks/useTenantNavigation"

// Icons
import { Close as CloseIcon } from "@mui/icons-material"
import DescriptionIcon from "@mui/icons-material/Description"
import PersonIcon from "@mui/icons-material/Person"
import BusinessIcon from "@mui/icons-material/Business"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import PaymentIcon from "@mui/icons-material/Payment"
import InventoryIcon from "@mui/icons-material/Inventory"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import StoreIcon from "@mui/icons-material/Store"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import HomeIcon from "@mui/icons-material/Home"
import ReceiptIcon from "@mui/icons-material/Receipt"
import PhoneIcon from "@mui/icons-material/Phone"
import SendIcon from "@mui/icons-material/Send"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import Inventory2Icon from "@mui/icons-material/Inventory2"
import EditNoteIcon from '@mui/icons-material/EditNote';

import { ErpContext } from "../../context/ErpContext.js"
import SpinnerLading from "../misc/SpinnerComponent.js"

const ModalViewTablaCompra = ({
  openModal,
  handleCloseModal,
  selectedTransaccion,
  selectedTransaccionEntidad,
  transaccionItems,
  compraItems,
}) => {
  const [calculatedTotal, setCalculatedTotal] = useState(0)
  const [totalMontoDescuento, setTotalMontoDescuento] = useState(0)
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(0)
  const [montoSinImpuesto, setMontoSinImpuesto] = useState(0)
  const [itemsMap, setItemsMap] = useState({})
  const [loading, setLoading] = useState(true)

  const { getItemById ,isNavbarCollapsed,
  } = useContext(ErpContext)

  const navigate = useTenantNavigation()

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedTransaccion && transaccionItems) {
          // Crear el mapa de ítems
          const itemsDetails = {}
          await Promise.all(
            transaccionItems.map(async (item) => {
              const itemDetails = await getItemById(item.idItem)
              if (itemDetails) {
                itemsDetails[item.idItem] = {
                  codigo: itemDetails.codigo,
                  descripcion: itemDetails.descripcion,
                }
              }
            }),
          )
          setItemsMap(itemsDetails)

          console.log(selectedTransaccion)

          console.log("compraItems:", compraItems)

          // Calcular montos
          const { montoTotal, impuestos = [], montoDescuento = 0, porcentajeDescuento = 0 } = selectedTransaccion

          // Calcular el monto total sin impuestos
          const totalSinImpuestos = impuestos.reduce((total, impuesto) => {
            return total - (impuesto.montoTotal || 0)
          }, montoTotal)

          // Aplicar descuentos
          const totalSinImpuestosYDescuento = totalSinImpuestos + montoDescuento
          const totalFinal = totalSinImpuestosYDescuento * (1 - porcentajeDescuento / 100)

          // Actualizar estados
          setCalculatedTotal(totalFinal)
          setTotalMontoDescuento(montoDescuento)
          setPorcentajeDescuento(porcentajeDescuento)
          setMontoSinImpuesto(totalSinImpuestos)
        }
      } catch (error) {
        console.error("Error al cargar los datos:", error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [selectedTransaccion, transaccionItems])

  const handleEditCompra = (transaccion) => {
    if (!transaccion) {
      console.error("No hay presupuesto disponible para editar")
      return
    }
    navigate(`editarCompraComponent/${transaccion.id}/${transaccion.idEstadoDeCompra}`)
  }

  // Renderiza el spinner mientras está cargando
  if (loading) {
    return <SpinnerLading />
  }

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-transaccion-titulo"
      aria-describedby="modal-transaccion-descripcion"
    >
      <Box
        className="modal-background"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxHeight: "90vh",
        }}
      >
        <Zoom in={openModal} timeout={300}>
          <Paper className="modal-container">
            {/* Header */}
            <Box
              sx={{
                bgcolor: "#5b5b5f",
                color: "white",
                p: 2,
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <ReceiptIcon />
                <Typography
                  variant="h6"
                  component="h2"
                  className="modal-title"
                  sx={{ color: "white", borderBottom: "none", m: 0, p: 0 }}
                >
                  Detalles de la Compra #{selectedTransaccion?.id}
                  {selectedTransaccion?.estadoDeCompra && (
                    <Chip
                      label={selectedTransaccion.estadoDeCompra}
                      size="small"
                      sx={{
                        ml: 2,
                        backgroundColor: alpha(
                          selectedTransaccion.estadoDeCompra === "Abierta"
                            ? "#2196F3"
                            : selectedTransaccion.estadoDeCompra === "Cerrada"
                              ? "#4CAF50"
                              : selectedTransaccion.estadoDeCompra === "Incompleta"
                                ? "#f44336"
                                : "#FF9800",
                          0.2,
                        ),
                        color:
                          selectedTransaccion.estadoDeCompra === "Abierta"
                            ? "#2196F3"
                            : selectedTransaccion.estadoDeCompra === "Cerrada"
                              ? "#4CAF50"
                              : selectedTransaccion.estadoDeCompra === "Incompleta"
                                ? "#f44336"
                                : "#FF9800",
                        fontWeight: "bold",
                        border: `1px solid ${
                          selectedTransaccion.estadoDeCompra === "Abierta"
                            ? "#2196F3"
                            : selectedTransaccion.estadoDeCompra === "Cerrada"
                              ? "#4CAF50"
                              : selectedTransaccion.estadoDeCompra === "Incompleta"
                                ? "#f44336"
                                : "#FF9800"
                        }`,
                      }}
                    />
                  )}
                </Typography>
                
              </Box>
              <IconButton
                onClick={handleCloseModal}
                sx={{ color: "white" }}
                className="close-button"
                aria-label="cerrar"
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Content */}
            <Box sx={{ p: 3 }}>
              {/* Información principal */}
              <Grid container spacing={3} sx={{ mb: 3 }}>
                {/* Datos ERP */}
                <Grid item xs={12} md={4}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #5b5b5f",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <BusinessIcon sx={{ color: "#5b5b5f" }} />
                        Datos ERP
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <CalendarTodayIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Fecha:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.createdAt}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <DescriptionIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Tipo:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.idTipoTransaccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <StoreIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Negocio:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.negocio || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <AccountCircleIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Usuario:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.usuario || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Ubicación:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.ubicacion || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Proveedor */}
                <Grid item xs={12} md={4}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid rgb(244, 177, 14)",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <PersonIcon sx={{ color: "rgb(244, 177, 14)" }} />
                        Datos del Proveedor
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <PersonIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Nombre:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.descripcionEntidad} {selectedTransaccion?.apellido || ""}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <DescriptionIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            DNI/CUIT:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.dniCuitCuil || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <HomeIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Dirección:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.direccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Localidad:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.localidad || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Provincia:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.provincia || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <PhoneIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Teléfono:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccionEntidad?.telefono || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Financieros */}
                <Grid item xs={12} md={4}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #4CAF50",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <AttachMoneyIcon sx={{ color: "#4CAF50" }} />
                        Datos Financieros
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {/* Total */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mt: 1,
                            p: 1,
                            bgcolor: alpha("#4CAF50", 0.1),
                            borderRadius: 1,
                          }}
                        >
                          <AttachMoneyIcon fontSize="small" sx={{ color: "#4CAF50" }} />
                          <Typography variant="body1" className="transaction-detail-label" fontWeight="bold">
                            Total:
                          </Typography>
                          <Typography variant="body1" className="value">
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(selectedTransaccion?.montoTotal || 0)}
                          </Typography>
                        </Box>

                        {/* Medios de Pago */}
                        <Box sx={{ mt: 1 }}>
                          <Typography
                            variant="body2"
                            className="transaction-detail-label"
                            sx={{
                              mb: 0.5,
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <PaymentIcon fontSize="small" />
                            Medios de Pago:
                          </Typography>

                          {selectedTransaccion?.pagos && selectedTransaccion.pagos.length > 0 ? (
                            selectedTransaccion.pagos.map((pago, idx) => (
                              <Box key={idx} sx={{ display: "flex", alignItems: "center", ml: 3, gap: 1 }}>
                                <Typography variant="body2" className="transaction-detail-label">
                                  • {pago.descripcion}:
                                </Typography>
                                <Typography variant="body2" className="value">
                                  {new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(pago.monto || 0)}
                                </Typography>
                              </Box>
                            ))
                          ) : (
                            <Typography variant="body2" sx={{ ml: 3, fontStyle: "italic" }}>
                              No hay información de pagos
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {selectedTransaccion?.textoDescripcion? (<Box  sx={{ mb: 3 }}>
                <Typography
                  variant="h6"
                  className="items-title"
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    color: "#5b5b5f",
                  }}
                >
                  <EditNoteIcon />
                  Nota por devolución
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: "bold" }}>
                  {selectedTransaccion.textoDescripcion}
                </Typography>
              </Box>) : (<></>)}

              {/* Tabla de Ítems */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="h6"
                  className="items-title"
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    color: "#5b5b5f",
                  }}
                >
                  <InventoryIcon />
                  Ítems de la Compra
                </Typography>

                <TableContainer
                  component={Paper}
                  elevation={3}
                  className="tableContainerItemList"
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    maxHeight: 300,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell className="table-header-cell">Descripción</TableCell>
                        <TableCell align="right" className="table-header-cell">
                          Cantidad
                        </TableCell>
                        <TableCell align="right" className="table-header-cell">
                          Recibido
                        </TableCell>
                        <TableCell align="center" className="table-header-cell">
                          Estado
                        </TableCell>
                        <TableCell align="right" className="table-header-cell">
                          Última Actualización
                        </TableCell>
                        <TableCell align="right" className="table-header-cell">
                          Precio Unitario
                        </TableCell>
                        <TableCell align="right" className="table-header-cell">
                          Descuento
                        </TableCell>
                        <TableCell align="right" className="table-header-cell">
                          Total
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {transaccionItems && transaccionItems.length > 0 ? (
                        transaccionItems.map((item, index) => {
                          const precio = item.precio || 0
                          const cantidad = item.cantidad || 0
                          const descuento = item.porcentajeDescuento || 0
                          const totalItem = (precio * cantidad * (1 - descuento / 100)).toFixed(2)

                          const foundItem = itemsMap[item.idItem]

                          // Buscar el item correspondiente en compraItems
                          const compraItem = compraItems?.find((ci) => ci.idItem === item.idItem) || {}
                          const cantidadRecibida = compraItem.totalCantidadRecibida || 0
                          const updatedAt = compraItem.fechaMasReciente
                            ? new Date(compraItem.fechaMasReciente).toLocaleString()
                            : "No disponible"

                          // Determinar el estado de satisfacción
                          const isSatisfied = cantidadRecibida === cantidad

                          return (
                            <TableRow
                              key={`${item.idTransaccion}-${item.idItem}-${index}`}
                              sx={{
                                transition: "background-color 0.2s ease",
                                "&:hover": {
                                  backgroundColor: alpha("#5b5b5f", 0.05),
                                },
                              }}
                            >
                              <TableCell className="table-cell">
                                <Typography variant="body2" fontWeight="medium">
                                  {foundItem ? `${foundItem.codigo} - ${foundItem.descripcion}` : "No encontrado"}
                                </Typography>
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                <Chip label={cantidad} size="small" color="primary" variant="outlined" />
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                <Chip
                                  label={cantidadRecibida}
                                  size="small"
                                  color={isSatisfied ? "success" : "warning"}
                                  variant="outlined"
                                />
                              </TableCell>
                              <TableCell align="center" className="table-cell">
                                {isSatisfied ? (
                                  <CheckCircleIcon sx={{ color: "#4CAF50" }} />
                                ) : (
                                  <Inventory2Icon sx={{ color: "orange" }} />
                                )}
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                <Typography variant="body2" color="text.secondary" fontSize="0.75rem">
                                  {updatedAt}
                                </Typography>
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(precio)}
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                {descuento > 0 ? (
                                  <Chip label={`${descuento}%`} size="small" color="secondary" variant="outlined" />
                                ) : (
                                  "0%"
                                )}
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                <span className="value">
                                  {new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(totalItem)}
                                </span>
                              </TableCell>
                            </TableRow>
                          )
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                            <Typography variant="body1" color="text.secondary">
                              No hay ítems para mostrar
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Descripción */}
              {selectedTransaccion?.descripcion && (
                <Box
                  sx={{
                    p: 2,
                    bgcolor: alpha("#f5f5f5", 0.5),
                    borderRadius: 2,
                    mb: 2,
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                    Descripción:
                  </Typography>
                  <Typography variant="body2">
                    {selectedTransaccion.afectaCuentaCorriente ? (
                      <>
                        <span style={{ color: "#4CAF50", fontWeight: "bold" }}>
                          [CC]
                        </span>
                        <span> {selectedTransaccion.descripcion}</span>
                      </>
                    ) : (
                      selectedTransaccion.descripcion
                    )}
                  </Typography>
                </Box>
              )}
              {/* Acciones */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  borderTop: "1px solid #eee",
                  pt: 2,
                }}
              >
                <Button
                  className="buttomOptionModal"
                  variant="contained"
                  endIcon={<SendIcon />}
                  onClick={() => handleEditCompra(selectedTransaccion)}
                  sx={{
                    bgcolor: "#5b5b5f",
                    "&:hover": {
                      bgcolor: alpha("#5b5b5f", 0.9),
                    },
                  }}
                >
                  Editar Compra
                </Button>
              </Box>
            </Box>
          </Paper>
        </Zoom>
      </Box>
    </Modal>
  )
}

export default ModalViewTablaCompra

